import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { defaultMissionInfData, getMissionInfos } from '@/api/missionInfo';
import Pagination from '@/components/Pagination/index.vue';
import EditorMission from './components/EditorMission.vue';
import DetailReading from './components/DetailReading.vue';
import DetailQuiz from '@/views/contents/mission/components/DetailQuiz.vue';
import { handArmFunctions, missionTypes, NOT_SET_NUMBER } from '@/utils/constants';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "tableKey", 0);
    _defineProperty(_this, "list", []);
    _defineProperty(_this, "total", 0);
    _defineProperty(_this, "listLoading", true);
    _defineProperty(_this, "listQuery", {
      page: 1,
      type: '',
      handArmFunction: '',
      limit: 20,
      title: ''
    });
    _defineProperty(_this, "handArmFunctions", handArmFunctions);
    _defineProperty(_this, "missionTypes", missionTypes);
    _defineProperty(_this, "edit", {
      showDialog: false,
      title: '',
      action: '',
      missionInfo: JSON.parse(JSON.stringify(defaultMissionInfData))
    });
    _defineProperty(_this, "detail", {
      showDialog: false,
      title: 'Detail Reading',
      action: 'view',
      missionInfo: JSON.parse(JSON.stringify(defaultMissionInfData))
    });
    _defineProperty(_this, "quizDetail", {
      showDialog: false,
      title: 'Detail Quiz',
      action: 'view',
      missionInfo: JSON.parse(JSON.stringify(defaultMissionInfData))
    });
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "onShowDialogChange",
    value: function onShowDialogChange(showDialog, oldValue) {
      if (showDialog === false) {
        this.getList();
      }
    }
  }, {
    key: "isShare",
    value: function isShare(url) {
      if (url === null || url === undefined || url === '') {
        return false;
      }
      return true;
    }
  }, {
    key: "isFree",
    value: function isFree(_isFree) {
      if (_isFree === null || _isFree === undefined || _isFree === false) {
        return false;
      }
      return true;
    }
  }, {
    key: "created",
    value: function created() {
      this.getList();
    }
  }, {
    key: "getList",
    value: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return getMissionInfos(this.listQuery);
            case 1:
              data = _context.v;
              this.list = data.items;
              this.total = data.total;
              this.listLoading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }()
  }, {
    key: "handleFilter",
    value: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.edit = {
        showDialog: true,
        title: 'Create Mission',
        action: 'create',
        missionInfo: JSON.parse(JSON.stringify(defaultMissionInfData))
      };
    }
  }, {
    key: "handleDetail",
    value: function handleDetail(mi) {
      this.detail = {
        showDialog: true,
        title: 'Edit Reading',
        action: 'edit',
        missionInfo: JSON.parse(JSON.stringify(mi))
      };
    }
  }, {
    key: "handleQuizDetail",
    value: function handleQuizDetail(mi) {
      this.quizDetail = {
        showDialog: true,
        title: 'Edit Quiz',
        action: 'edit',
        missionInfo: JSON.parse(JSON.stringify(mi))
      };
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(mi) {
      this.edit = {
        showDialog: true,
        title: 'Edit Mission',
        action: 'edit',
        missionInfo: JSON.parse(JSON.stringify(mi))
      };
    }
  }]);
}(Vue);
__decorate([Watch('edit.showDialog', {
  deep: true
})], default_1.prototype, "onShowDialogChange", null);
default_1 = __decorate([Component({
  name: 'ReadingList',
  components: {
    Pagination: Pagination,
    EditorMission: EditorMission,
    DetailReading: DetailReading,
    DetailQuiz: DetailQuiz
  },
  filters: {
    handArmFunctionLabel: function handArmFunctionLabel(handArmFunction) {
      if (handArmFunction) {
        if (handArmFunction === 'LIMITED') {
          handArmFunction = 'STABILIZER';
        }
        var found = handArmFunctions.find(function (hf) {
          return hf.key === handArmFunction;
        });
        if (found) return found.label;
      }
      return '';
    },
    dayLabel: function dayLabel(day) {
      if (day === NOT_SET_NUMBER) {
        return '';
      } else {
        return day;
      }
    },
    shareLabel: function shareLabel(url) {
      if (url === null || url === undefined || url === '') {
        return 'Off';
      }
      return 'ON';
    },
    isFreeLabel: function isFreeLabel(isFree) {
      if (isFree === null || isFree === undefined || isFree === false) {
        return 'Off';
      }
      return 'ON';
    },
    typeLabel: function typeLabel(type) {
      return type != null && type === 'BASICS' ? 'EXERCISE' : type;
    }
  }
})], default_1);
export default default_1;